import { parseCookies } from "nookies";
import { Button } from "@react-md/button";
import { NavLink } from "react-router-dom";
import { useEffect, useState } from "react";

import Order from "./order";
import Slider from "./slider";
import Support from "./support";
import Options from "./options";
import CardAnimation from "./card-animation";

import { setPageMeta, SITE_URL } from "../../shared/helpers/seo";
import { useT } from "../../i18n";

import styles from "./home.module.scss";
import variables from "../../styles/variables.module.scss";

const Homepage = () => {
  const t = useT();
  const { accessToken } = parseCookies(null);
  const [selectedPackage, setPackage] = useState("");
  const handleClickScroll = () => {
    const element = document.getElementById("order");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    setPageMeta({
      title: "Touch Talk — NFC Business Cards",
      path: "/",
      jsonLd: {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Touch Talk",
        url: SITE_URL,
        logo: `${SITE_URL}/logo_rounded.png`,
      },
    });
    const selected = sessionStorage.getItem("package");
    if (selected) {
      setPackage(selected);
      handleClickScroll();
    }
  }, []);
  return (
    <div
      className={`${styles.container} ${variables.scrollable} ${variables.row}`}
    >
      <h1 className="sr-only">Touch Talk — NFC business cards</h1>
      <section className="flex flex-col items-center gap-3 w-full max-w-[560px] mx-auto py-6 text-center">
        <h2 className="m-0 text-2xl sm:text-3xl font-bold text-white leading-tight">
          {t("home.reachTitle")}
        </h2>
        <p className="m-0 text-base text-white/70 leading-relaxed">{t("home.reachText")}</p>
      </section>
      <CardAnimation />
      <img src={"/text.svg"} alt="Touch Talk" />
      <Options />
      <Slider />
      {!accessToken && (
        <div className={`${styles.login} ${variables.row}`}>
          <span className={variables.title}>
            {t("home.loginHint")}
          </span>
          <NavLink to="login">
            <Button className={variables.containedBtn} themeType="contained">
              {t("common.signIn")}
            </Button>
          </NavLink>
        </div>
      )}
      {selectedPackage && (
        <div id="order" style={{ width: "100%" }}>
          <Order selected={selectedPackage} setSelected={setPackage} />
        </div>
      )}
      <Support />
    </div>
  );
};

export default Homepage;
